import { createSlice } from '@reduxjs/toolkit'

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    location: null,
  },
  reducers: {
    resetAnalyticsLocation: (state) => {
      state.location = null
    },
    setAnalyticsLocation: (state, { payload }) => {
      state.location = payload
    },
  },
})

export const {
  reducer,
  actions: { resetAnalyticsLocation, setAnalyticsLocation },
} = analyticsSlice
